<template>
    <vCommodityFlowAdjustmentLineList :postList="postList" v-if="flag"></vCommodityFlowAdjustmentLineList>
</template>
<script>
import vCommodityFlowAdjustmentLineList from '../../listComponent/basicdata/commodityFlowAdjustmentLine/commodityFlowAdjustmentLineComponent.vue';
export default {
    name: 'commodityFlowAdjustmentLineList',
    components: {
        vCommodityFlowAdjustmentLineList
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>